@let strokeWidth = 2.25;
@let strokeLinecap = 'round';
@let strokeLinejoin = 'round';
@let pathDef =
  'M1.875 12.373V14.623 M24.375 12.373V14.623 M6.375 5.62305V21.373 M10.875 8.62305V18.373 M15.375 4.125V22.875 M19.875 8.62305V18.373 M28.875 12.373V14.623 M51.375 12.373V14.623 M33.375 5.62305V21.373 M37.875 8.62305V18.373 M42.375 4.125V22.875 M46.875 8.62305V18.373 M55.875 12.373V14.623 M78.375 12.373V14.623 M60.375 5.62305V21.373 M64.875 8.62305V18.373 M69.375 4.125V22.875 M73.875 8.62305V18.373 M82.875 12.373V14.623 M105.375 12.373V14.623 M87.375 5.62305V21.373 M91.875 8.62305V18.373 M96.375 4.125V22.875 M100.875 8.62305V18.373 M109.875 12.373V14.623 M132.375 12.373V14.623 M114.375 5.62305V21.373 M118.875 8.62305V18.373 M123.375 4.125V22.875 M127.875 8.62305V18.373';

<div class="display-flex">
  <svg
    height="27"
    viewBox="0 0 134 27"
    width="134"
    xmlns="http://www.w3.org/2000/svg"
    [ngClass]="`progress--${theme()}`"
  >
    <g>
      <path
        class="background"
        [attr.d]="pathDef"
        [attr.stroke-linecap]="strokeLinecap"
        [attr.stroke-linejoin]="strokeLinejoin"
        [attr.stroke-width]="strokeWidth"
      />
    </g>

    <g [attr.mask]="`url(#${id})`">
      <path
        class="mask"
        [attr.d]="pathDef"
        [attr.stroke-linecap]="strokeLinecap"
        [attr.stroke-linejoin]="strokeLinejoin"
        [attr.stroke-width]="strokeWidth"
      />
    </g>

    <defs>
      <mask [attr.id]="id">
        <rect
          class="progress__bar"
          fill="white"
          height="100%"
          width="100%"
          x="0"
          y="0"
          [style.transform]="`scaleX(${progress() / 100})`"
        />
      </mask>
    </defs>
  </svg>
</div>
